<div class="col1">
  <div class="header">
    <h1>{{ statsTitle }}</h1>
  </div>

  @if (stats$ | async; as stats) {
    <div class="board">
      <div class="board-row board-header">
        <div class="board-cell board-label board-corner"></div>
        <div class="board-cell board-heading">Total Inbound</div>
        <div class="board-cell board-heading">Total Callbacks</div>
        <div class="board-cell board-heading">Handled / Abandoned</div>
        <div class="board-cell board-heading">Calls Waiting</div>
        <div class="board-cell board-heading">ASA</div>
        <div class="board-cell board-heading">Longest Wait Time</div>
      </div>
      @for (stat of stats.data; track stat.queueId) {
        <div class="board-row">
          <div class="board-cell board-label">{{ stat.queueName || 'Unknown queue' }}</div>
          <div class="board-cell board-value">{{ stat?.totalCalls || 0 }}</div>
          <div class="board-cell board-value">{{ stat?.callbacksHandled || 0 }}</div>
          <div class="board-cell board-value">{{ stat?.contactsHandled || 0 }} / {{ stat?.contactsAbandoned || 0 }}</div>
          <div class="board-cell board-value">{{ stat?.callsWaiting || 0 }}</div>
          <div class="board-cell board-value">{{ stat?.ASA || 0 }}</div>
          <div class="board-cell board-value board-wait" [ngClass]="{ alert: stat?.oldestContactOverThreshold }">
            {{ stat?.oldestContact }}
          </div>
        </div>
      }
      <div class="board-row board-total">
        <div class="board-cell board-label">TOTAL CALL QUEUES</div>
        <div class="board-cell board-value">{{ stats.dataSummary?.totalCalls }}</div>
        <div class="board-cell board-value">{{ stats.dataSummary?.callbacksHandled }}</div>
        <div class="board-cell board-value">{{ stats.dataSummary?.contactsHandled }} / {{ stats.dataSummary?.contactsAbandoned }}</div>
        <div class="board-cell board-value" [ngClass]="{ alert: stats.dataSummary?.callsWaitingOverThreshold }">
          {{ stats.dataSummary?.callsWaiting }}
        </div>
        <div class="board-cell board-value">{{ stats.dataSummary?.ASA }}</div>
        <div class="board-cell board-value board-wait">{{ stats.dataSummary?.oldestContact }}</div>
      </div>
    </div>
  }
  <app-status-summary [available]="available" [notAvailable]="notAvailable" [outOfOffice]="outOfOffice"></app-status-summary>
</div>
<div class="col2">
  <div class="header">
    <h1>{{ agentsTitle }}</h1>
  </div>
  @if (agentPages$ | async; as agentPages) {
    <swiper-container
      #statsSwiper
      class="wallboard-slides"
      init="false"
      >
      @for (page of agentPages; track $index) {
        <swiper-slide>
          <div class="page">
            @for (statusGroup of page; track statusGroup) {
              <app-card-frame
                [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName"
                class="frame"
                >
                @for (agent of statusGroup; track agent) {
                  <app-agent-card [agent]="agent"> </app-agent-card>
                }
              </app-card-frame>
            }
          </div>
        </swiper-slide>
      }
    </swiper-container>
  }
</div>
